/*
  mf-analytics.js — camada de eventos GA4 da loja.

  Regras que este arquivo NAO quebra:
  1. Nada sai daqui sem consentimento de estatistica (window.mfConsent.analytics).
     Antes disso os eventos ficam numa fila local; se a pessoa recusar, a fila e descartada.
  2. Zero dado pessoal. So id, nome, marca, categoria, preco e quantidade de produto.
     Nunca e-mail, CPF, telefone, endereco ou termo digitado.
     (Politica do Google Analytics: proibido enviar dados que identifiquem a pessoa.)
  3. item_id = SKU da variante, o MESMO offerId do feed do Merchant Center. E assim
     que GA4, Shopping e Google Ads falam do mesmo produto.
  4. begin_checkout e purchase NAO saem daqui. Quem dispara os dois e o checkout
     (seguro.modafemininaoficial.shop), que ja manda pra mesma property.
     Repetir aqui inflaria o funil e a receita — dado inflado e dado mentiroso.
*/
(function () {
  'use strict';

  var D = window.MF_DATA || {};
  var MOEDA = D.moeda || 'BRL';
  var fila = [];
  var LIMITE = 40;
  var jaMandou = {};

  function consentiu() {
    return !!(window.mfConsent && window.mfConsent.analytics);
  }

  function manda(nome, params) {
    if (!consentiu()) {
      if (fila.length < LIMITE) { fila.push([nome, params]); }
      return;
    }
    if (typeof window.gtag !== 'function') { return; }
    window.gtag('event', nome, params);
  }

  function umaVezPorPagina(chave) {
    if (jaMandou[chave]) { return false; }
    jaMandou[chave] = true;
    return true;
  }

  function esvazia() {
    if (typeof window.gtag !== 'function') { return; }
    var pendentes = fila.slice();
    fila.length = 0;
    for (var i = 0; i < pendentes.length; i++) {
      window.gtag('event', pendentes[i][0], pendentes[i][1]);
    }
  }

  document.addEventListener('lgpd:consent', function (e) {
    var c = e && e.detail;
    if (c && c.analytics) { window.setTimeout(esvazia, 0); }
    else { fila.length = 0; }
  });

  /* ------------------------------------------------------------- itens */

  function itemDaVariante(v, quantidade, posicao) {
    if (!v) { return null; }
    var item = {
      item_id: v.sku || ('shopify_' + v.id),
      item_name: v.nome,
      price: typeof v.preco === 'number' ? v.preco : undefined,
      quantity: quantidade || 1,
      currency: MOEDA
    };
    if (v.marca) { item.item_brand = v.marca; }
    if (v.categoria) { item.item_category = v.categoria; }
    if (v.variante && v.variante !== 'Default Title') { item.item_variant = v.variante; }
    if (typeof posicao === 'number') { item.index = posicao; }
    return item;
  }

  function valorDe(itens) {
    var t = 0;
    for (var i = 0; i < itens.length; i++) {
      if (typeof itens[i].price === 'number') { t += itens[i].price * (itens[i].quantity || 1); }
    }
    return Math.round(t * 100) / 100;
  }

  /* ------------------------------------------------------------ eventos */

  // view_item — pagina de produto
  if (D.produto && umaVezPorPagina('view_item')) {
    var it = itemDaVariante(D.produto, 1);
    if (it) { manda('view_item', { currency: MOEDA, value: it.price, items: [it] }); }
  }

  // view_item_list — colecao
  if (D.lista && D.lista.itens && D.lista.itens.length && umaVezPorPagina('view_item_list')) {
    var listaItens = [];
    for (var i = 0; i < D.lista.itens.length; i++) {
      var li = itemDaVariante(D.lista.itens[i], 1, i);
      if (li) { listaItens.push(li); }
    }
    if (listaItens.length) {
      manda('view_item_list', {
        item_list_id: D.lista.id,
        item_list_name: D.lista.nome,
        items: listaItens
      });
    }
  }

  // view_cart — carrinho
  if (D.carrinho && D.carrinho.itens && D.carrinho.itens.length && umaVezPorPagina('view_cart')) {
    var carrinhoItens = [];
    for (var j = 0; j < D.carrinho.itens.length; j++) {
      var ci = itemDaVariante(D.carrinho.itens[j], D.carrinho.itens[j].quantidade);
      if (ci) { carrinhoItens.push(ci); }
    }
    if (carrinhoItens.length) {
      manda('view_cart', { currency: MOEDA, value: valorDe(carrinhoItens), items: carrinhoItens });
    }
  }

  // select_item — clique num card de produto
  document.addEventListener('click', function (e) {
    if (!D.porHandle) { return; }
    var a = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
    if (!a) { return; }
    var m = /\/products\/([a-z0-9\-_%]+)/i.exec(a.getAttribute('href') || '');
    if (!m) { return; }
    var v = D.porHandle[m[1]];
    if (!v) { return; }
    var item = itemDaVariante(v, 1);
    if (!item) { return; }
    manda('select_item', {
      item_list_id: D.lista ? D.lista.id : undefined,
      item_list_name: D.lista ? D.lista.nome : undefined,
      items: [item]
    });
  }, true);

  // add_to_cart — o tema avisa com o evento 'product:added' (detail: {variant, quantity})
  document.addEventListener('product:added', function (e) {
    var det = (e && e.detail) || {};
    var qtd = parseInt(det.quantity, 10) || 1;
    var v = null;

    if (det.variant && det.variant.id && D.porVariante) {
      v = D.porVariante[String(det.variant.id)];
    }
    // Caminho do "comprar rapido" no card: o tema manda variant:null. Cai no formulario.
    if (!v) {
      var form = e.target && e.target.closest ? e.target.closest('form[action*="/cart/add"]') : null;
      var campo = form ? form.querySelector('[name="id"]') : null;
      if (campo && D.porVariante) { v = D.porVariante[String(campo.value)]; }
    }
    if (!v && D.produto) { v = D.produto; }
    mandaAddToCart(v, qtd);
  }, true);

  // O botao "Comprar agora" da PDP envia o formulario nativo e a pagina navega — nesse
  // caminho o tema nunca chega a disparar 'product:added'. O submit cobre esse caso.
  // Os dois caminhos sao deduplicados por variante numa janela de 2s.
  var ultimoAdd = { id: null, t: 0 };
  function jaContou(id) {
    var agora = new Date().getTime();
    if (ultimoAdd.id === id && agora - ultimoAdd.t < 2000) { return true; }
    ultimoAdd = { id: id, t: agora };
    return false;
  }

  function mandaAddToCart(v, qtd) {
    var item = itemDaVariante(v, qtd);
    if (!item || jaContou(item.item_id)) { return; }
    manda('add_to_cart', { currency: MOEDA, value: valorDe([item]), items: [item] });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) { return; }
    var campoId = form.querySelector('[name="id"]');
    var campoQtd = form.querySelector('[name="quantity"]');
    var v = (campoId && D.porVariante) ? D.porVariante[String(campoId.value)] : null;
    if (!v) { v = D.produto; }
    mandaAddToCart(v, campoQtd ? (parseInt(campoQtd.value, 10) || 1) : 1);
  }, true);

  // variant:changed — atualiza o produto corrente da PDP pra que add_to_cart use o preco certo
  document.addEventListener('variant:changed', function (e) {
    var det = (e && e.detail) || {};
    if (det.variant && det.variant.id && D.porVariante && D.porVariante[String(det.variant.id)]) {
      D.produto = D.porVariante[String(det.variant.id)];
    }
  }, true);
})();
